var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSmartphone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 10,
    viewBox: "0 0 10 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.00016 7.50065H5.00433M2.91683 0.833984H7.0835C7.54373 0.833984 7.91683 1.20708 7.91683 1.66732V8.33398C7.91683 8.79422 7.54373 9.16732 7.0835 9.16732H2.91683C2.45659 9.16732 2.0835 8.79422 2.0835 8.33398V1.66732C2.0835 1.20708 2.45659 0.833984 2.91683 0.833984Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmartphone);
export default __webpack_public_path__ + "static/media/Smartphone.1f9292ae3dcae23611226d2e57535c4b.svg";
export { ForwardRef as ReactComponent };